package org.vreo.devicehub.features.core.data.device.dto

import kotlinx.serialization.Serializable

/**
 * Device request Dto. Used for device to account linking, device details update and new
 * production device registration.
 *
 * @property productNumber product number of device
 * @property serialNumber device serial number
 * @property tag device tag, optional
 * @property linkingKey linking key/password for device
 */
@Serializable
data class AnprDeviceRequestDto(
    val productNumber: String,
    val serialNumber: Long,
    val tag: String? = null,
    val linkingKey: String? = null
)